/**
 * TutorialPage.jsx
 * Página de seleção de roteiros do tutorial guiado.
 * Exibe o mascote Guto e uma grade de cards para o usuário escolher o tour.
 */
import React from 'react';
import { TOURS } from '../../data/tours';
import './TutorialPage.css';

export default function TutorialPage({ onNavigate, onStartTour }) {
  return (
    <main className="tut-page">
      <div className="tut-container">

        <header className="tut-page-header">
          <button
            className="tut-back-btn"
            onClick={() => onNavigate('home')}
            aria-label="Voltar ao mapa principal"
          >
            ← Voltar ao Mapa
          </button>
          <h1 className="tut-page-title">Tutorial Interativo</h1>
        </header>

        {/* Guto + pergunta */}
        <section className="tut-hero" aria-label="Apresentação do tutorial">
          <div className="tut-hero__mascote-wrap" aria-hidden="true">
            <img src="/mascote.png" alt="" className="tut-hero__guto" />
          </div>
          <div className="tut-hero__speech">
            <div className="tut-hero__bubble">
              <p className="tut-hero__ask">O que você quer aprender?</p>
              <p className="tut-hero__sub">
                Escolha um roteiro abaixo e eu te guio pela interface real do
                painel, passo a passo — com destaque em cada elemento!
              </p>
            </div>
          </div>
        </section>

        {/* Grade de cards de tour */}
        <section aria-labelledby="tut-tours-title">
          <h2 id="tut-tours-title" className="sr-only">Roteiros disponíveis</h2>
          <div className="tut-tours-grid">
            {TOURS.map((tour) => (
              <article key={tour.id} className="tut-tour-card">
                <span className="tut-tour-card__icon" aria-hidden="true">
                  {tour.icone}
                </span>
                <h3 className="tut-tour-card__title">{tour.titulo}</h3>
                <p className="tut-tour-card__desc">{tour.descricao}</p>
                <div className="tut-tour-card__footer">
                  <span className="tut-tour-card__steps">
                    {tour.totalPassos} passos
                  </span>
                  <button
                    className="tut-tour-card__btn"
                    onClick={() => onStartTour(tour.id)}
                    aria-label={`Iniciar roteiro: ${tour.titulo}`}
                  >
                    Iniciar →
                  </button>
                </div>
              </article>
            ))}
          </div>
        </section>

        <p className="tut-hint">
          <strong>Dica:</strong> durante o tour use as setas ← → para navegar e <strong>ESC</strong> para fechar a qualquer momento.
        </p>

      </div>
    </main>
  );
}
